var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { State } from "vuex-class";
import NumberRange from "~/components/common/number-range.vue";
import CaseExcelImport from "~/components/case-import/case-excel-import.vue";
import CaseBatchConfirm from "~/components/case-import/case-batch-confirm.vue";
import { PageService } from "~/utils/page.service";
import { CaseInfoService } from "~/services/domain-service/case-info.service";
import { DataImportExcelInfoService } from "~/services/dataimp-service/data-import-excel-info.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import { ReminderService, ReminderMessageType } from "~/utils/reminder.service";
import { Subscription } from "rxjs";
import CaseBatchDelete from '~/components/case-import/case-batch-delete.vue';
import CaseFileImport from '~/components/case-import/case-file-import.vue';
var IntroductionCase = /** @class */ (function (_super) {
    __extends(IntroductionCase, _super);
    function IntroductionCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            caseExcelImport: false,
            confirmBatch: false,
            deleteBatch: false,
            fileDialog: false
        };
        _this.batchList = [];
        _this.subscriptions = {
            IMPORT_EXCEL: new Subscription(),
            CONFIRM_CASE: new Subscription()
        };
        _this.caseDetail = "";
        _this.introductionModel = {
            caseNumber: '',
            batchNumber: '',
            principalName: '',
            personalName: '',
            principalId: '',
            partnerName: '',
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            amountRange: { min: '', max: '' }
        };
        _this.deleteImport = {
            batchNumber: ""
        };
        _this.introductionDataSet = [];
        _this.introductionRule = {};
        _this.steplength = 0;
        return _this;
    }
    Object.defineProperty(IntroductionCase.prototype, "isImported", {
        //判断是否有批次号
        get: function () {
            return this.batchList.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    //获取案件列表
    IntroductionCase.prototype.refreshData = function () {
        var _this = this;
        this.importExcelService
            .getAllImportExcelInfos(this.introductionModel, this.pageService)
            .subscribe(function (data) {
            _this.introductionDataSet = data;
        });
        this.updateBatchList();
    };
    IntroductionCase.prototype.mounted = function () {
        this.refreshData();
        // 注册消息监听,用于业务自动刷新
        // 刷新数据列表
        this.subscriptions.IMPORT_EXCEL = ReminderService.getInstance()
            .addListener(ReminderMessageType.Background, "IMPORT_EXCEL")
            .subscribe(this.refreshData);
        // 更新每个批次详情，用于在案件确认时
        this.subscriptions.CONFIRM_CASE = ReminderService.getInstance()
            .addListener(ReminderMessageType.Background, "CONFIRM_CASE")
            .subscribe(this.updateBatchList);
    };
    // 页面销毁前注销对事件的监听
    IntroductionCase.prototype.beforeDestroy = function () {
        this.subscriptions.IMPORT_EXCEL.unsubscribe();
        this.subscriptions.CONFIRM_CASE.unsubscribe();
    };
    /**
     * 更新批次数据
     */
    IntroductionCase.prototype.updateBatchList = function () {
        var _this = this;
        this.importExcelService.getAllBatchNumbers().subscribe(function (data) {
            _this.batchList = data;
        });
    };
    /**
     * 重置numberRange
     */
    IntroductionCase.prototype.follFeedback = function () {
        this.introductionModel.dayRange = { min: "", max: "" };
        this.introductionModel.amountRange = { min: "", max: "" };
        this.introductionModel.caseMoney = { min: "", max: "" };
    };
    /**
     * 进入查看执行页
     */
    IntroductionCase.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Case_imported,
            hiddenCaseList: true,
            hiddenAction: true,
            hiddenCollectionStatus: true
        });
    };
    IntroductionCase.prototype.onClickfileImport = function () {
        this.dialog.fileDialog = true;
    };
    IntroductionCase.prototype.close = function () {
        var from = this.$refs['case-file-import'];
        from.reset();
    };
    __decorate([
        State
    ], IntroductionCase.prototype, "principalList", void 0);
    __decorate([
        Dependencies(PageService)
    ], IntroductionCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], IntroductionCase.prototype, "caseInfoService", void 0);
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], IntroductionCase.prototype, "importExcelService", void 0);
    IntroductionCase = __decorate([
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                CaseExcelImport: CaseExcelImport,
                CaseBatchConfirm: CaseBatchConfirm,
                CaseBatchDelete: CaseBatchDelete,
                CaseFileImport: CaseFileImport
            }
        })
    ], IntroductionCase);
    return IntroductionCase;
}(Vue));
export default IntroductionCase;
